import * as wjcCore from '@mescius/wijmo';
import * as wjcGrid from '@mescius/wijmo.grid';

'use strict';

import {ViewChild, Component, OnInit} from '@angular/core';
import {Store} from "@ngrx/store";

import {ToasterService} from "angular2-toaster";

import {ActivePromotionConfig} from "../config/active-promotion.config";
import {asOrientDate, DataService, isOrientDate, OrientDBCollectionView} from "@cosbeni/database";
import {DomSanitizer} from '@angular/platform-browser';

@Component({
    standalone: false,
    selector: 'cj-user-auction',
    templateUrl: 'auction.component.html',
})

export class AuctionComponent implements OnInit {
    readonly: Boolean = true;
    @ViewChild('auctionGrid') auctionGrid: wjcGrid.FlexGrid;
    screenWidth: number;
    auctions: OrientDBCollectionView;
    items: wjcCore.CollectionView = new wjcCore.CollectionView([]);
    mode: string = "view";
    tableType: string = "image";
    auction: any = {};
    destination: any = {};
    optionAuction: any[] = [];
    optionPlace: any[] = [];
    optionStatus: any[] = [];
    optionLane: any[] = [];
    newses: any[] = [];
    selectAll: Boolean = false;
    counter: number = 1;

    constructor(public store: Store<any>, public dataService: DataService, public toasterService: ToasterService,private sanitized: DomSanitizer) {
        this.auctions = new OrientDBCollectionView(dataService, ActivePromotionConfig.DATABASE, "SELECT FROM DA_Auction", "DA_Auction", "", 0, 100, true, true, false)
        this.auctions.url = ActivePromotionConfig.SERVER_URL;
        this.auctions.tokenName = ActivePromotionConfig.DATABASE + "_token";
        this.auctions.itemsSourceFunction = function (items: any[]) {
            for (let item of items) {
                if (isOrientDate(item.eventDate)) {
                    item.eventDate = asOrientDate(item.eventDate);
                }
            }
            return items;
        }
        this.auctions.preSaveChangesFunction = function (sourceItems) {
            let items = [];
            for (let sourceItem of sourceItems) {
                let item = Object.assign({}, sourceItem);
                if (wjcCore.isDate(sourceItem.eventDate)) {
                    item.eventDate = wjcCore.Globalize.formatDate(sourceItem.eventDate, 'yyyy-MM-dd');
                }
                items.push(item);
            }
            return items;
        }.bind(this);
        this.auctions.sortDescriptions.push(new wjcCore.SortDescription("eventDate", false));
        this.dataService.query({
            sql: "SELECT FROM DA_News WHERE public = true order by newsDate",
            count: "SELECT FROM DA_News WHERE public = true order by newsDate",
            fetchPlan: "*:1",
        }, ActivePromotionConfig.SERVER_URL).subscribe(data => {
            this.newses = []
            if (wjcCore.isArray(data.results)) {
               this.newses = data.results;
            }
        })
        this.dataService.query({
            sql: "SELECT FROM DA_Master WHERE category ='会場名' order by sort",
            count: "SELECT FROM DA_Master WHERE category ='会場名' order by sort",
            fetchPlan: "*:1",
        }, ActivePromotionConfig.SERVER_URL).subscribe(data => {
            this.optionPlace = []
            if (wjcCore.isArray(data.results)) {
                for (let item of data.results) {
                    this.optionPlace.push(item.value);
                }
            }
        })
        this.dataService.query({
            sql: "SELECT FROM DA_Master WHERE category ='開催状態' order by sort",
            count: "SELECT FROM DA_Master WHERE category ='開催状態' order by sort",
            fetchPlan: "*:1",
        }, ActivePromotionConfig.SERVER_URL).subscribe(data => {
            this.optionStatus = []
            if (wjcCore.isArray(data.results)) {
                for (let item of data.results) {
                    this.optionStatus.push(item.value);
                }
            }
        })
        this.dataService.query({
            sql: "SELECT FROM DA_Master WHERE category ='レーン' order by sort",
            count: "SELECT FROM DA_Master WHERE category ='レーン' order by sort",
            fetchPlan: "*:1",
        }, ActivePromotionConfig.SERVER_URL).subscribe(data => {
            this.optionLane = []
            if (wjcCore.isArray(data.results)) {
                for (let item of data.results) {
                    this.optionLane.push(item.value);
                }
            }
        })
        this.mode = "view";
        this.resizeScreen();
    }

    resizeScreen(event?) {
        this.screenWidth = window.innerWidth;
    }

    ngOnInit() {
        this.auctions.currentChanged.addHandler(this.onCurrentChanged, this);
        this.auctions.filterOnServer = true;
    }

    onCurrentChanged(sender: any, args: wjcCore.EventArgs): void {
        if (this.auctions.currentItem != null) {
            this.auction = Object.assign({}, this.auctions.currentItem);
            this.loadItems();
        }
    }

    loadItems() {
        if (this.auctions.currentItem != null) {
            let where = [];
            where.push("auction = " + this.auctions.currentItem['@rid']);
            where.push("published >= date('2000-01-01','yyyy-MM-dd')");
            this.dataService.query({
                sql: "SELECT FROM DA_Item WHERE " + where.join(" AND "),
                count: "SELECT FROM DA_Item WHERE " + where.join(" AND "),
                fetchPlan: "*:1",
            }, ActivePromotionConfig.SERVER_URL).subscribe(data => {
                if (wjcCore.isArray(data.results)) {
                    this.items.trackChanges = true;
                    this.items.sourceCollection = data.results;
                    this.items.refresh();
                }
            })
        }
    }

    getImageSrc(item, name): string {
        return ActivePromotionConfig.IMAGE_URL + item.id + '/' + name;
    }

    refresh(grid: string): void {
        this[grid].invalidate();
    }

}

